import { render } from "./SpondLogin.vue?vue&type=template&id=db208cf0"
import script from "./SpondLogin.vue?vue&type=script&lang=ts"
export * from "./SpondLogin.vue?vue&type=script&lang=ts"
script.render = render

export default script